import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Privacy Policy
        </h1>
        <div className="prose max-w-none">
          <p className="text-sm text-gray-500 italic mb-6">Last Updated: March 30, 2026</p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">1. Introduction</h2>
          <p className="text-gray-600 mb-4">
            This Privacy Policy explains how we handle information when you use the Divorce Property Calculator.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">2. Information We Do Not Collect</h2>
          <p className="text-gray-600 mb-4">
            We do not collect, store, or retain any personal information that you enter into the calculator forms. This includes:
          </p>
          <ul className="list-disc list-inside text-gray-600 mb-4 ml-4 space-y-2">
            <li>Names, addresses, contact details</li>
            <li>Financial data (assets, debts, income)</li>
            <li>Marriage or family details</li>
          </ul>
          <p className="text-gray-600 mb-4">
            All input data exists only temporarily in your browser’s memory and is processed solely to generate your report. After the report is emailed to you, all input data is permanently deleted from our systems.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">3. Information We May Collect</h2>
          <div className="mb-4">
            <h3 className="text-lg font-medium text-gray-700 mb-2">Payment Information:</h3>
            <p className="text-gray-600 mb-3">
              When you make a payment through Stripe, Stripe collects your payment details. We receive only a payment confirmation and the email address you provide to receive the report. We do not store credit card numbers.
            </p>
          </div>
          <div className="mb-4">
            <h3 className="text-lg font-medium text-gray-700 mb-2">Usage Data:</h3>
            <p className="text-gray-600 mb-3">
              We may use standard analytics (e.g., page visits, time on site) to improve the Site. This data is aggregated and does not identify you personally.
            </p>
          </div>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">4. How We Use Information</h2>
          <p className="text-gray-600 mb-4">
            The email address you provide is used only to send you your report and to communicate regarding your purchase. It is not stored after the report is sent unless you choose to subscribe to updates (if such option is offered).
          </p>
          <p className="text-gray-600 mb-4">
            Payment information is handled entirely by Stripe, which is PCI‑compliant.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">5. Data Security</h2>
          <p className="text-gray-600 mb-4">
            We use industry‑standard measures to protect your data during transmission. Because we do not store user data, the risk of data breach is minimized.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">6. Third‑Party Services</h2>
          <p className="text-gray-600 mb-4">
            We use Stripe for payments and a third‑party email service to deliver reports. Each service has its own privacy policy, which we encourage you to review.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">7. Children’s Privacy</h2>
          <p className="text-gray-600 mb-4">
            The Site is not intended for children under 18. We do not knowingly collect information from minors.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">8. Changes to This Policy</h2>
          <p className="text-gray-600 mb-4">
            We may update this Privacy Policy occasionally. The “Last Updated" date at the top indicates when changes were made.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">9. Contact Us</h2>
          <p className="text-gray-600 mb-4">
            If you have questions about this Privacy Policy, you can contact us at: hi@tapnop.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
